import { FormContainerBaseTypes } from './form-container-types'
import {
  Label,
  LabelProps,
  RadioGroup,
  RadioGroupProps,
  SizableText,
  SizeTokens,
  SpaceTokens,
  XStack,
  XStackProps,
  YStack,
} from 'tamagui'
import { FormFieldContainer } from './form-field-container'

export type RadioGroupFieldProps = RadioGroupProps &
  FormContainerBaseTypes & {
    options?: { label: string; value: string; helperText?: string }[]
    children?: React.ReactNode
    size?: SizeTokens
    name?: string
    spaceItem?: SpaceTokens
    optionProps?: XStackProps
  }

export function RadioGroupField({
  options,
  required,
  error,
  helperText,
  helperTextProps,
  label,
  labelInline,
  labelProps,
  size = '$3',
  spaceItem = '$2',
  showRequired = true,
  showValidationIcon = false,
  optionProps,
  children,
  ...rest
}: RadioGroupFieldProps) {
  return (
    <FormFieldContainer
      error={error}
      required={required}
      labelProps={labelProps}
      label={label}
      size={size}
      labelInline={labelInline}
      helperText={helperText}
      helperTextProps={helperTextProps}
      showRequired={showRequired}
      showValidationIcon={showValidationIcon}
    >
      <RadioGroup gap={rest.flexDirection === 'row' ? '$4' : '$2'} required={required} {...rest}>
        {children}
        {options &&
          options.map((option, i) => (
            <XStack
              flex={1}
              key={`${rest.name}-${option.value}-${i}`}
              ai="center"
              gap={spaceItem}
              {...optionProps}
            >
              <RadioGroup.Item
                value={option.value}
                id={`${rest.name}-${option.value}-${i}`}
                size={size}
                theme="gray"
              >
                <RadioGroup.Indicator />
              </RadioGroup.Item>

              <YStack>
                <Label height="auto" htmlFor={`${rest.name}-${option.value}-${i}`} cursor="pointer">
                  {option.label}
                </Label>
                {option.helperText && <SizableText color="$grey8">{option.helperText}</SizableText>}
              </YStack>
            </XStack>
          ))}
      </RadioGroup>
    </FormFieldContainer>
  )
}
